import React from 'react';
import { SelectInstance } from 'react-select';
import { KitFormInfoText, KitFormLabel } from './KitFormControls';
import KitSelect, { KitSelectProps } from './KitSelect';

export interface KitFormSelectProps extends Omit<KitSelectProps, 'inputId'> {
  id: string;
  label?: string;
  labelAs?: 'label' | 'h4';
  required?: boolean;
}

export const KitFormSelect = React.forwardRef<SelectInstance, KitFormSelectProps>(
  ({ id, label, labelAs, required, infoMessage, ...rest }, ref) => {
    const infoTextId = `${id}Info`;
    return (
      <>
        {label && <KitFormLabel required={required} text={label} htmlFor={id} as={labelAs} />}
        <KitSelect
          id={`${id}Wrapper`}
          inputId={id}
          data-qa-id={id}
          aria-describedby={infoMessage ? infoTextId : undefined}
          ref={ref}
          {...rest}
        />
        {infoMessage && (
          <KitFormInfoText
            text={infoMessage}
            isError={rest.isError}
            id={infoTextId}
            data-qa-id={infoTextId}
            aria-live='polite'
          />
        )}
      </>
    );
  }
);
